import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GlossaryRoutingModule } from './glossary-routing.module';
import { GlossaryComponent } from '@app/main/glossary/glossary.component';
import { SharedModule } from '@shared/shared.module';

@NgModule({
    declarations: [GlossaryComponent],
    imports: [CommonModule, SharedModule, GlossaryRoutingModule]
})
export class GlossaryModule {}
